import React from 'react'
import { forwardRef, styled } from '@grupoboticario/flora-react-system'
import { HTMLFloraProps } from '@grupoboticario/flora-react-utils'

const StyledBox = styled('div', {
  boxSizing: 'border-box',
})

export type BoxProps = HTMLFloraProps<'div'>

/**
 * @component
 * @name Box
 * @description
 * Base component
 * @example
 * <Box as="div" css={{}} />
 * @tutorial https://flora.gb.tech/docs/components/core/box
 */
export const Box = forwardRef<'div', BoxProps>((props, forwardedRef) => {
  return <StyledBox ref={forwardedRef} {...props} />
})
